import { render } from "./Logo.vue?vue&type=template&id=ed83ef94&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=ed83ef94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ed83ef94"

export default script